import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
} from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { NavigateNext, NavigateBefore } from '@material-ui/icons';
import classNames from 'classnames';

const styles = theme => ({
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
  },
  flexContent: {
    flex: '0 1 0',
    padding: '7px 0 7px 0',
  },
  page: {
    width: '24px',
    height: '24px',
    borderRadius: '6px',
    fontSize: '14px',
    color: 'black',
    backgroundColor: 'white',
    border: 'solid 1px #0043496a',
  },
  activePage: {
    backgroundColor: '#afafaf',
  },
  itemIcon: {
    minWidth: '40px',
  },
});

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pages: [] };
    this.getPages = this.getPages.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    const { currentPage, totalPages } = this.props;
    this.getPages(totalPages, currentPage);
  }

  componentDidUpdate(prevProps) {
    const { currentPage, totalPages } = this.props;
    if (
      prevProps.currentPage !== currentPage ||
      prevProps.totalPages !== totalPages
    ) {
      this.getPages(totalPages, currentPage);
    }
  }

  handlePageChange(page) {
    const { currentPage, hasPrevPage, hasNextPage } = this.props;
    if (page < currentPage && !hasPrevPage) {
      return;
    }
    if (page > currentPage && !hasNextPage) {
      return;
    }
    this.props.onPageChange(page);
  }

  getPages(totalPages, currentPage) {
    currentPage = currentPage || 1;
    var startPage, endPage;
    if (totalPages <= 10) {
      startPage = 1;
      endPage = totalPages;
    } else if (currentPage <= 6) {
      startPage = 1;
      endPage = 10;
    } else if (currentPage + 4 >= totalPages) {
      startPage = totalPages - 9;
      endPage = totalPages;
    } else {
      startPage = currentPage - 5;
      endPage = currentPage + 4;
    }
    var pages = [...Array(endPage + 1 - startPage).keys()].map(
      i => startPage + i
    );
    this.setState({ pages });
  }

  render() {
    const { pages } = this.state;
    const {
      classes,
      currentPage,
      totalPages,
      hasNextPage,
      hasPrevPage,
    } = this.props;
    return (
      <List className={classes.flexRow}>
        <ListItem
          key={'previous'}
          disableGutters
          className={classes.flexContent}
          onClick={() => this.handlePageChange(currentPage - 1)}
          disabled={!hasPrevPage}
        >
          <ListItemIcon className={classes.itemIcon}>
            <Avatar className={classes.page} id="previous">
              <NavigateBefore />
            </Avatar>
          </ListItemIcon>
        </ListItem>
        {pages.map((page, index) => (
          <ListItem key={index} disableGutters className={classes.flexContent}>
            <ListItemIcon className={classes.itemIcon}>
              <Avatar
                className={
                  page === currentPage
                    ? classNames(classes.page, classes.activePage)
                    : classes.page
                }
                onClick={() => this.handlePageChange(page)}
              >
                {page}
              </Avatar>
            </ListItemIcon>
          </ListItem>
        ))}
        <ListItem
          key={'next'}
          disableGutters
          className={classes.flexContent}
          onClick={() => this.handlePageChange(currentPage + 1)}
          disabled={!hasNextPage}
        >
          <ListItemIcon className={classes.itemIcon}>
            <Avatar id="next" className={classes.page}>
              <NavigateNext />
            </Avatar>
          </ListItemIcon>
        </ListItem>
        <ListItem key={'pageCount'} disableGutters>
          <ListItemText primary={'Page ' + currentPage + ' of ' + totalPages} />
        </ListItem>
      </List>
    );
  }
}

Pagination.defaultProps = {
  currentPage: 1,
  totalPages: 1,
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  classes: PropTypes.object,
  onPageChange: PropTypes.func,
  hasNextPage: PropTypes.bool.isRequired,
  hasPrevPage: PropTypes.bool.isRequired,
};

Pagination = compose(withStyles(styles, { withTheme: true }))(Pagination);

export default Pagination;
